import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from '@angular/core';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { IPasswordRecoveryParams } from 'src/app/interfaces/patient.interfaces';
import { LoadService } from 'src/app/services/application/load.service';
import { AuthService } from 'src/app/services/auth.service';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent-service';
import { Utils } from 'src/app/services/utils';
import { AlertService } from 'src/lib/ariadna/alert';

@Component({
    selector: 'app-auth-recovery-entry-pass',
    templateUrl: './entry-pass.component.html',
    styleUrls: ['../../_auth-shared-styles.scss'],
    standalone: false,
})
export class RecoveryEntryPassComponent implements OnInit, AfterViewInit {
    public AuthFormTitle: string = '';
    public AccessReg: boolean = false;
    public hidePassword: boolean = true;
    public hidePasswordRep: boolean = true;
    public loading: boolean = false;
    public errorMessage: string = '';
    public formNewPass: FormGroup = new FormGroup(
        {
            password: new FormControl<string>('', [
                Validators.minLength(3),
                Validators.required,
            ]),
            passwordRepeat: new FormControl<string>('', [
                Validators.minLength(3),
                Validators.required,
            ]),
        },
        { validators: this.passwordMatchValidator },
    );
    @ViewChild('InputBlockPass') public InputBlockPass: ElementRef | undefined;
    @ViewChild('InputBlockPassRep') public InputBlockPassRep:
        ElementRef | undefined;
    public constructor(
        private load: LoadService,
        private auth: AuthService,
        private alert: AlertService,
        private cookieService: CookieConsentService,
        private router: Router,
    ) {
        this.AuthFormTitle =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .AUTH_FORM_TEXT ?? 'Личный кабинет пациента';
        this.AccessReg =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_REGISTRATION_ENABLED;
    }
    public ngOnInit(): void {}
    public ngAfterViewInit(): void {
        this.setFocus();
    }
    public passwordMatchValidator(
        control: AbstractControl,
    ): ValidationErrors | null {
        const password = control.get('password')?.value;
        const passwordRepeat = control.get('passwordRepeat')?.value;

        if (password && passwordRepeat && password !== passwordRepeat) {
            return { passwordMismatch: true };
        }
        return null;
    }
    // Отправка введенных паролей и перенаправление на страницу логина
    public async onSubmitPass() {
        this.loading = true;
        const recoveryParams: IPasswordRecoveryParams = {
            newPassword: this.formNewPass.controls['password'].value,
            newPasswordRepeat:
                this.formNewPass.controls['passwordRepeat'].value,
        };
        try {
            await lastValueFrom(this.auth.recoveryPassword(recoveryParams));
            this.alert.success('Пароль успешно изменен.', 9000);
            this.cookieService.deleteCookie('pa-web_Patient_Local');
            this.router.navigate(['/auth/login']);
        } catch (err: unknown) {
            const errorMessage = Utils.getErrorMessage(
                err,
                'Ошибка при смене пароля',
            );
            console.error('Ошибка на /auth/recovery_password', errorMessage);
            this.alert.error(errorMessage);
        } finally {
            this.loading = false;
        }
    }
    public setFocus() {
        if (this.InputBlockPass) {
            this.InputBlockPass.nativeElement.focus();
        }
    }
    public checkInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        input.value = input.value.replace(/\s/g, '');
    }
    public goToRegistration() {
        this.router.navigate(['auth/register']);
    }

    public focusNextInput(event: Event): void {
        event.preventDefault();

        const target = event.target as HTMLElement;
        const form = target.closest('form');

        if (!form) {
            return;
        }

        const inputs = Array.from(
            form.querySelectorAll<HTMLInputElement>(
                'input:not([disabled]):not([readonly])',
            ),
        );

        const currentIndex = inputs.indexOf(target as HTMLInputElement);
        const nextInput = inputs[currentIndex + 1];

        if (nextInput) {
            nextInput.focus();
            return;
        }

        const button = form.querySelector<HTMLButtonElement>(
            'button[type="submit"]:not([disabled])',
        );

        if (button) {
            button.click();
        }

        target.blur();
    }
}
